import { useState, useEffect } from 'react';

export const useMobileWarning = () => {
  const [showMobileWarning, setShowMobileWarning] = useState(false);
  const [hasAcceptedWarning, setHasAcceptedWarning] = useState(false);

  useEffect(() => {
    // Check if user is on mobile and hasn't accepted the warning yet
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isEditor = window.location.pathname.includes('editor') || 
                     window.location.pathname.includes('create-content') || 
                     window.location.pathname.includes('caption') || 
                     window.location.pathname.includes('ai-video-editor');
    
    if (isMobile && isEditor && !hasAcceptedWarning) {
      setShowMobileWarning(true);
    }
  }, [hasAcceptedWarning]);

  const handleMobileWarningClose = () => {
    setShowMobileWarning(false);
  };

  const handleMobileWarningContinue = () => {
    setShowMobileWarning(false);
    setHasAcceptedWarning(true);
  };

  return {
    showMobileWarning,
    handleMobileWarningClose,
    handleMobileWarningContinue,
  };
};
